import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import logo from "../assets/images/logo.png";

export const Navbar = () => {
  return (
    <nav className="navbar navbar-expand-lg navbar-light">
      <div className="container">
        <Link className="navbar-brand" to="/">
          {/* <h2 className="logo">Ajibadde</h2> */}
          <img
            src={logo}
            alt="Ajibadde"
            style={{ width: "250px", height: "50px" }}
          />
        </Link>
        <button
          className="navbar-toggler"
          type="button"
          data-toggle="collapse"
          data-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <FontAwesomeIcon icon={faBars} style={{ color: "bisque" }} />
        </button>

        <div className="collapse navbar-collapse" id="navbarSupportedContent">
          <ul className="navbar-nav ml-auto">
            <li className="nav-item active">
              <Link className="nav-link" to="/">
                Home <span className="sr-only">(current)</span>
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/about">
                about me
              </Link>
            </li>
            <li className="nav-item">
              <a className="nav-link" href="https://ajibaddemotiv.hashnode.dev/">
                Blog
              </a>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/projects">
                project
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/contact">
                contact us
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};
